module.exports = __webpack_public_path__ + "img/online.0fd5469f.png";